import { ChatState } from "PFApp/components/chat/chat_states";
import { ActionIcon } from "PFComponents/action_icon";
import { Inline } from "PFComponents/containers";

import css from "./chat.module.scss";
import { ChatDropdownToggleIcon } from "./chat_dropdown_toggle_icon";

type ChatHeaderActionsProps = {
  chatState: ChatState;
  expandable: boolean;
  expanded: boolean;
  dropdownOpen: boolean;
  onMinimize: (event?: React.SyntheticEvent) => void;
  onExpand: (event?: React.SyntheticEvent) => void;
  onClose: (event?: React.SyntheticEvent) => void;
  onToggleDropdown: (open: boolean) => void;
};

export const ChatHeaderActions = ({
  chatState,
  expandable,
  expanded,
  dropdownOpen,
  onMinimize,
  onExpand,
  onClose,
  onToggleDropdown
}: ChatHeaderActionsProps) => (
  <Inline alignItems="center" justifyContent="end" className={css.headerActions} data-qa-id="chat-all-header">
    <ActionIcon name="subtract" size="sm" disableHover onClick={onMinimize} />
    {expandable && (
      <ActionIcon name={expanded ? "collapse" : "expand"} size="sm" disableHover onClick={onExpand} />
    )}
    <ChatDropdownToggleIcon
      chatState={chatState}
      dropdownOpen={dropdownOpen}
      onToggleDropdown={onToggleDropdown}
    />
    <ActionIcon name="cross" size="xxs" onClick={onClose} disableHover />
  </Inline>
);
